import {BASE_API_URL} from '../constants'
import Token from "./Token";


export const SessionApi = {
    start: (payload) => {
        return fetch(
            BASE_API_URL + '/api/start-session',
            {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
    stop: (sessionUuid) => {
        return fetch(
            BASE_API_URL + '/api/stop-session',
            {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({"sessionUUID": sessionUuid}),
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
}